// Keep a carried display value visible, but do not offer a disallowed save.
export function languageOptions(options, configured, current) {
  const allowed = Array.isArray(configured)
    ? configured.map(code => String(code).trim().toLowerCase()) : [];
  return options.filter(option => !allowed.length || option.value === 'en' || allowed.includes(option.value) || option.value === current)
    .map(option => ({ ...option, disabled: !!allowed.length && option.value !== 'en' && !allowed.includes(option.value) }));
}



// WEBPACK FOOTER //
// ./src/utils/languageOptions.js